import React from 'react';
import css from './ListingPage.module.css';
import { PrimaryButtonInline } from '../../components';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { closeListingInProgressIdSelector } from './ListingPage.duck';
const ListingPageActionButtons = ({ handleDelete, handleEdit, listingId }) => {
  const closeListingInProgressId = useSelector(closeListingInProgressIdSelector);
  return (
    <div className={css.listingActionButtons}>
      <PrimaryButtonInline className={css.editButton} onClick={handleEdit}>
        <FormattedMessage id="ListingPage.edit" defaultMessage="Edit" />
      </PrimaryButtonInline>
      <PrimaryButtonInline
        type="button"
        inProgress={closeListingInProgressId === listingId}
        className={css.deleteButton}
        onClick={handleDelete}
      >
        <FormattedMessage id="ListingPage.delete" defaultMessage="Delete" />
      </PrimaryButtonInline>
    </div>
  );
};

export default ListingPageActionButtons;
